export var isSectionInView = function isSectionInView(containerRef, sectionRef, isDesktop) {
  if (!(containerRef !== null && containerRef !== void 0 && containerRef.current) || !(sectionRef !== null && sectionRef !== void 0 && sectionRef.current)) {
    return false;
  }
  var top = containerRef.current.scrollTop - (isDesktop ? 92 : 76);
  return top < sectionRef.current.offsetTop + sectionRef.current.offsetHeight && top + containerRef.current.offsetHeight > sectionRef.current.offsetTop;
};
export var isStartDiverMove = function isStartDiverMove(dividerRef, sectionRef) {
  if (!dividerRef.current || !sectionRef.current) {
    return false;
  }
  return dividerRef.current.offsetTop - 20 > sectionRef.current.offsetTop;
};